module.exports = __webpack_public_path__ + "img/莲子.2d64285e.jpg";